import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'
import { CarbonCalculator } from 'src/components/organisms/CarbonCalculator'

// "Using the calculator" section of /native-trees-carbon-calculator. Wraps the
// Tāne's Tree Trust CarbonCalculator organism with rebranded heading + intro.
const CarbonCalculatorSectionRebrand = () => (
  <section className='bg-linen'>
    <div className='container mx-auto flex flex-col gap-6 px-4 py-12 lg:px-20'>
      <h2 className='font-display-rebrand text-[25px] md:text-5xl font-extrabold leading-[100%] mt-0 mb-4 text-forestDeep'>
        Using the calculator
      </h2>
      <div className='flex flex-col gap-4'>
        <TypographyRebrand variant='introduction' color='forestDeep'>
          The amount of CO₂ your trees are capable of absorbing is based on a
          50-year timeframe of continuous growth.
        </TypographyRebrand>
        <TypographyRebrand variant='introduction' color='forestDeep'>
          Remember, if you are calculating based on annual emissions, such as
          the use of your car or household activities, trees will need to be
          planted each year based on your annual carbon emissions — not just as
          a one-off.
        </TypographyRebrand>
      </div>
      <CarbonCalculator />
    </div>
  </section>
)

export default CarbonCalculatorSectionRebrand
